'use client'

import { useEffect } from 'react'
import { ColorSchemeScript, MantineProvider, mantineHtmlProps } from '@mantine/core'
import ErrorState from '../components/ErrorState'
import { cssVariablesResolver, theme } from '@lib/theme'

interface GlobalErrorPageProps {
    error: Error & { digest?: string }
    reset: () => void
}

export default function GlobalErrorPage({ error, reset }: GlobalErrorPageProps) {
    useEffect(() => {
        console.error(error)
    }, [error])

    return (
        <html lang='en' {...mantineHtmlProps}>
            <head>
                <ColorSchemeScript forceColorScheme='light' />
            </head>
            <body>
                <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver} forceColorScheme='light'>
                    <ErrorState
                        title='The app could not load'
                        description='A critical error interrupted the page. Try reloading the app.'
                        digest={error.digest}
                        reset={reset}
                    />
                </MantineProvider>
            </body>
        </html>
    )
}
